import { Provider } from '@angular/core';
import { environment } from '@orderna/admin-panel/src/environments/environment';
import { AllTransactionsApiService } from '../../services/analytics/accounting/all-transactions/all-transactions-api.service';
import { AllTransactionsMockApiService } from '../../services/analytics/accounting/all-transactions/all-transactions-mock-api.service';
import { DailyTransactionsApiService } from '../../services/analytics/accounting/daily-transactions/daily-transactions-api.service';
import { DailyTransactionsMockApiService } from '../../services/analytics/accounting/daily-transactions/daily-transactions-mock-api.service';
import { BillingInvoicesApiService } from '../../services/billing-invoices/billing-invoices-api.service';
import { BillingInvoicesMockApiService } from '../../services/billing-invoices/billing-invoices-mock-api.service';
import { CashDrawersApiService } from '../../services/cash-drawers/cash-drawers-api.service';
import { CashDrawersMockApiService } from '../../services/cash-drawers/cash-drawers-mock-api.service';
import { CategoriesApiService } from '../../services/categories/categories-api.service';
import { CategoriesMockApiService } from '../../services/categories/categories-mock-api.service';
import { CustomersApiService } from '../../services/customers/customers-api.service';
import { CustomersMockApiService } from '../../services/customers/customers-mock-api.service';
import { DiscountsApiService } from '../../services/discounts/discounts-api.service';
import { DiscountsMockApiService } from '../../services/discounts/discounts-mock-api.service';
import { FeedbacksApiService } from '../../services/feedbacks/feedbacks-api.service';
import { FeedbacksMockApiService } from '../../services/feedbacks/feedbacks-mock-api.service';
import { InventoryApiService } from '../../services/inventory/inventory-api.service';
import { InventoryMockApiService } from '../../services/inventory/inventory-mock-api.service';
import { ProductsApiService } from '../../services/products/products-api.service';
import { ProductsMockApiService } from '../../services/products/products-mock-api.service';
import { PurchasesApiService } from '../../services/purchases/purchases-api.service';
import { PurchasesMockApiService } from '../../services/purchases/purchases-mock-api.service';
import { AverageTransactionValueApiService } from '../../services/analytics/sales/average-transaction-value/average-transaction-value-api.service';
import { AverageOrderValuesMockApiService } from '../../services/analytics/sales/average-transaction-value/average-transaction-value-mock-api.service';
import { SalesByCategoryApiService } from '../../services/analytics/sales/sales-by-category/sales-by-category-api.service';
import { SalesByCategoryMockApiService } from '../../services/analytics/sales/sales-by-category/sales-by-category-mock-api.service';
import { SalesByDayOfWeekApiService } from '../../services/analytics/sales/sales-by-day-of-week/sales-by-day-of-week-api.service';
import { SalesByDayOfWeekMockApiService } from '../../services/analytics/sales/sales-by-day-of-week/sales-by-day-of-week-mock-api.service';
import { DiscountSummaryApiService } from '../../services/analytics/sales/discount-summary/discount-summary-api.service';
import { DiscountSummaryMockApiService } from '../../services/analytics/sales/discount-summary/discount-summary-mock-api.service';
import { DiscountedTransactionsApiService } from '../../services/analytics/sales/discounted-transactions/discounted-transactions-api.service';
import { DiscountedTransactionsMockApiService } from '../../services/analytics/sales/discounted-transactions/discounted-transactions-mock-api.service';
import { FailedTransactionsApiService } from '../../services/analytics/sales/failed-transactions/failed-transactions-api.service';
import { FailedTransactionsMockApiService } from '../../services/analytics/sales/failed-transactions/failed-transactions-mock-api.service';
import { SalesByProductApiService } from '../../services/analytics/sales/sales-by-product/sales-by-product-api.service';
import { SalesByProductMockApiService } from '../../services/analytics/sales/sales-by-product/sales-by-product-mock-api.service';
import { RefundedTransactionsApiService } from '../../services/analytics/sales/refunded-transactions/refunded-transactions-api.service';
import { RefundedTransactionsMockApiService } from '../../services/analytics/sales/refunded-transactions/refunded-transactions-mock-api.service';
import { RevenueApiService } from '../../services/analytics/sales/revenue/revenue-api.service';
import { RevenueMockApiService } from '../../services/analytics/sales/revenue/revenue-mock-api.service';
import { SalesByTimeOfDayApiService } from '../../services/analytics/sales/sales-by-time-of-day/sales-by-time-of-day-api.service';
import { SalesByTimeOfDayMockApiService } from '../../services/analytics/sales/sales-by-time-of-day/sales-by-time-of-day-mock-api.service';
import { TipsByDayApiService } from '../../services/analytics/sales/tips-by-day/tips-by-day-api.service';
import { TipsByDayMockApiService } from '../../services/analytics/sales/tips-by-day/tips-by-day-mock-api.service';
import { ZReadingApiService } from '../../services/sale-readings/z-reading/z-reading-api.service';
import { DashboardApiService } from '../../services/dashboard/dashboard-api.service';
import { DashboardMockApiService } from '../../services/dashboard/dashboard-mock-api.service';
import { PlansApiService } from '../../services/plans/plans-api.service';
import { PlansMockApiService } from '../../services/plans/plans-mock-api.service';
import { SuppliersApiService } from '../../services/suppliers/suppliers-api.service';
import { SuppliersMockApiService } from '../../services/suppliers/suppliers-mock-api.service';
import { TransactionsApiService } from '../../services/transactions/transactions-api.service';
import { TransactionsMockApiService } from '../../services/transactions/transactions-mock-api.service';
import { UserProfilesApiService } from '../../services/user-profiles/user-profiles-api.service';
import { UserProfilesMockApiService } from '../../services/user-profiles/user-profiles-mock-api.service';
import { UsersApiService } from '../../services/users/users-api.service';
import { UsersMockApiService } from '../../services/users/users-mock-api.service';
import { CashRegisterSessionAnalyticsApiService } from '../../services/analytics/registers/sessions/cash-register-sessions-api.service';
import { CashRegisterSesssionsMockApiService } from '../../services/analytics/registers/sessions/cash-register-sessions-mock-api.service';

export const serviceProviders: Provider[] = [
  {
    provide: UsersApiService,
    useClass:
      environment.mode == 'prod' && environment.service.users == true ? UsersApiService : UsersMockApiService,
  },
  {
    provide: CustomersApiService,
    useClass:
      environment.mode == 'prod' && environment.service.customer == true 
        ? CustomersApiService
        : CustomersMockApiService,
  },
  {
    provide: TransactionsApiService,
    useClass:
      environment.mode == 'prod' && environment.service.transactions == true 
        ? TransactionsApiService
        : TransactionsMockApiService,
  },
  {
    provide: SuppliersApiService,
    useClass:
      environment.mode == 'prod' && environment.service.suppliers == true 
        ? SuppliersApiService
        : SuppliersMockApiService,
  },
  {
    provide: ProductsApiService,
    useClass:
      environment.mode == 'prod' && environment.service.products == true ? ProductsApiService : ProductsMockApiService,
  },
  {
    provide: DiscountsApiService,
    useClass:
      environment.mode == 'prod' && environment.service.discounts == true 
        ? DiscountsApiService
        : DiscountsMockApiService,
  },
  {
    provide: UserProfilesApiService,
    useClass:
      environment.mode == 'prod' && environment.service.userProfiles == true
        ? UserProfilesApiService
        : UserProfilesMockApiService,
  },
  {
    provide: PlansApiService,
    useClass:
      environment.mode == 'prod' && environment.service.subscriptionPlans == true
        ? PlansApiService
        : PlansMockApiService,
  },
  {
    provide: BillingInvoicesApiService,
    useClass:
      environment.mode == 'prod' && environment.service.billingInvoices == true
        ? BillingInvoicesApiService
        : BillingInvoicesMockApiService,
  },
  {
    provide: FeedbacksApiService,
    useClass:
      environment.mode == 'prod' && environment.service.feedbacks == true
        ? FeedbacksApiService
        : FeedbacksMockApiService,
  },
  {
    provide: InventoryApiService,
    useClass:
      environment.mode == 'prod' && environment.service.inventory == true
        ? InventoryApiService
        : InventoryMockApiService,
  },
  {
    provide: PurchasesApiService,
    useClass:
      environment.mode == 'prod' && environment.service.purchases == true
        ? PurchasesApiService
        : PurchasesMockApiService,
  },
  {
    provide: RevenueApiService,
    useClass:
      environment.mode == 'prod' && environment.service.revenues == true ? RevenueApiService : RevenueMockApiService,
  },
  {
    provide: AverageTransactionValueApiService,
    useClass:
      environment.mode == 'prod' && environment.service.averageTransactionValue == true
        ? AverageTransactionValueApiService
        : AverageOrderValuesMockApiService,
  },
  {
    provide: SalesByDayOfWeekApiService,
    useClass:
      environment.mode == 'prod' && environment.service.dayOfWeekSales == true
        ? SalesByDayOfWeekApiService
        : SalesByDayOfWeekMockApiService,
  },
  {
    provide: SalesByTimeOfDayApiService,
    useClass:
      environment.mode == 'prod' && environment.service.timeOfDaySales == true
        ? SalesByTimeOfDayApiService
        : SalesByTimeOfDayMockApiService,
  },
  {
    provide: SalesByProductApiService,
    useClass:
      environment.mode == 'prod' && environment.service.productSales == true
        ? SalesByProductApiService
        : SalesByProductMockApiService,
  },
  {
    provide: SalesByCategoryApiService,
    useClass:
      environment.mode == 'prod' && environment.service.categorySales == true
        ? SalesByCategoryApiService
        : SalesByCategoryMockApiService,
  },
  {
    provide: TipsByDayApiService,
    useClass:
      environment.mode == 'prod' && environment.service.tipsByDays == true
        ? TipsByDayApiService
        : TipsByDayMockApiService,
  },
  {
    provide: DiscountSummaryApiService,
    useClass:
      environment.mode == 'prod' && environment.service.discountSummaries == true
        ? DiscountSummaryApiService
        : DiscountSummaryMockApiService,
  },
  {
    provide: DiscountedTransactionsApiService,
    useClass:
      environment.mode == 'prod' && environment.service.discountedTransactions == true
        ? DiscountedTransactionsApiService
        : DiscountedTransactionsMockApiService,
  },
  {
    provide: RefundedTransactionsApiService,
    useClass:
      environment.mode == 'prod' && environment.service.refundedTransactions == true
        ? RefundedTransactionsApiService
        : RefundedTransactionsMockApiService,
  },
  {
    provide: FailedTransactionsApiService,
    useClass:
      environment.mode == 'prod' && environment.service.failedTransactions == true
        ? FailedTransactionsApiService
        : FailedTransactionsMockApiService,
  },
  {
    provide: DailyTransactionsApiService,
    useClass:
      environment.mode == 'prod' && environment.service.dailySummaries == true
        ? DailyTransactionsApiService
        : DailyTransactionsMockApiService,
  },
  {
    provide: AllTransactionsApiService,
    useClass:
      environment.mode == 'prod' && environment.service.allTransactions == true
        ? AllTransactionsApiService
        : AllTransactionsMockApiService,
  },
  {
    provide: CashRegisterSessionAnalyticsApiService,
    useClass:
      environment.mode == 'prod' && environment.service.cashRegisterSessions == true
        ? CashRegisterSessionAnalyticsApiService
        : CashRegisterSesssionsMockApiService,
  },
  {
    provide: CashDrawersApiService,
    useClass:
      environment.mode == 'prod' && environment.service.cashDrawers == true
        ? CashDrawersApiService
        : CashDrawersMockApiService,
  },
  {
    provide: DashboardApiService,
    useClass:
      environment.mode == 'prod' && environment.service.dashboard== true ? DashboardApiService : DashboardMockApiService,
  },
  {
    provide: CategoriesApiService,
    useClass:
      environment.mode == 'prod' && environment.service.categories == true
        ? CategoriesApiService
        : CategoriesMockApiService,
  },
];
